import type {
  DestinationFormValue,
  DestinationTranslationValue,
} from '@/shared/api/types/destination-types'

/*
 * * VI: Snapshot là chuỗi JSON ổn định của từng phần; form so snapshot hiện tại với snapshot lúc tải/lưu gần nhất để biết phần nào "dirty".
 * * EN: A snapshot is a stable JSON string of one part; the form compares the current one with the snapshot taken at load/last save to tell what is dirty.
 */

export function buildDestinationFormSnapshot(form: DestinationFormValue): string {
  return JSON.stringify(form)
}

/** Texts are trimmed so whitespace-only differences never mark the form dirty. */
export function buildDestinationTranslationSnapshot(
  translations: DestinationTranslationValue[],
): string {
  return JSON.stringify(
    translations.map((item) => ({
      language: item.language,
      title: (item.title ?? '').trim(),
      name: (item.name ?? '').trim(),
      description: (item.description ?? '').trim(),
    })),
  )
}
